// Get Billing Transactions
export const GET_BILLING_TRANSACTIONS_REQUEST = 'GET_BILLING_TRANSACTIONS_REQUEST';
export const GET_BILLING_TRANSACTIONS_DONE = 'GET_BILLING_TRANSACTIONS_DONE';
export const GET_BILLING_TRANSACTIONS_FAILED = 'GET_BILLING_TRANSACTIONS_FAILED';
export const GET_BILLING_TRANSACTIONS_RESET = 'GET_BILLING_TRANSACTIONS_RESET';

//Operations
export const BILLING_TRANSACTIONS_SET_PAGE = 'BILLING_TRANSACTIONS_SET_PAGE';
